import moment from "moment";

const MYANMAR_UTC_OFFSET_MINUTES = 6 * 60 + 30;

export const isBeforeMyanmarOperationalDayRollover = (now = moment()) => {
  const myanmarNow = moment(now).utcOffset(MYANMAR_UTC_OFFSET_MINUTES);
  const newOperationalDay = myanmarNow
    .clone()
    .startOf("day")
    .add({ hours: 10, minutes: 30, seconds: 1 });

  return myanmarNow.isBefore(newOperationalDay);
};

export const getMyanmarOperationalDate = (now = moment()) => {
  const myanmarNow = moment(now).utcOffset(MYANMAR_UTC_OFFSET_MINUTES);

  if (isBeforeMyanmarOperationalDayRollover(myanmarNow)) {
    return myanmarNow.subtract(1, "day").format("YYYY-MM-DD");
  }

  return myanmarNow.format("YYYY-MM-DD");
};

export const getOperationalDateRange = (startDate, endDate) => ({
  start_date: moment(startDate)
    .startOf("day")
    .add({ hours: 10, minutes: 30 })
    .format("YYYY-MM-DD HH:mm:ss"),
  end_date: moment(endDate)
    .startOf("day")
    .add({ days: 1, hours: 10, minutes: 30 })
    .format("YYYY-MM-DD HH:mm:ss"),
});
